import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { LocaleComponent } from '../Locale/locale.component';

@Component({
    standalone: true,
    selector: 'app-dismiss-alert',
    templateUrl: './dismiss-alert.component.html',
    imports: [LocaleComponent]
})
export class DismissAlertComponent {
  @ViewChild('alert', { static: true }) alert!: ElementRef;

  @Input() localeKey!: string;
  @Input() localeView!: string;
  @Input() alertType!: string;
  @Input() closeType = '';
  @Input() additionalContent = '';

  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }

}